import Frame from "./path-groups/Frame";
import Me from "./path-groups/Me";

import { PaperScope, Size } from "paper/dist/paper-core";

export default class Logo {
  private scope: paper.PaperScope;

  constructor(canvas: HTMLCanvasElement) {
    this.scope = new PaperScope();
    this.scope.setup(canvas);
    this.scope.view.viewSize = new Size(window.innerWidth, window.innerHeight);
  }

  frame: Frame | null = null;
  me: Me | null = null;

  async draw() {
    this.frame = new Frame();
    this.me = new Me();

    await this.frame.animateIn();
    await this.me.animateIn();
  }
}
